import { render, staticRenderFns } from "./boardSM3.vue?vue&type=template&id=556fa28c&scoped=true&"
import script from "./boardSM3.vue?vue&type=script&lang=js&"
export * from "./boardSM3.vue?vue&type=script&lang=js&"
import style0 from "./boardSM3.vue?vue&type=style&index=0&id=556fa28c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556fa28c",
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QBtnDropdown,QMarkupTable,QCheckbox,QInput,QCard,QCardSection} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QBtnDropdown,QMarkupTable,QCheckbox,QInput,QCard,QCardSection}, component.options.components || {})
